import React, { useCallback, useRef } from "react";
// @ts-ignore
import Timeout from "NodeJS.Timeout";

import { ModalTemplate } from "../modal-template/modal-template.component";
import { InfiniteScrollModalProps } from "./infinite-scroll-modal.props";
import { useInfiniteScrollModalStyles } from "./infinite-scroll-modal.styles";

export const InfiniteScrollModal = (props: InfiniteScrollModalProps) => {
  const classes = useInfiniteScrollModalStyles();

  const throttleDelay = props.throttleDelay ?? 2000;
  const nextThreshold = props.threshold ?? 150;

  const lastScrollTop = useRef<number>(0);
  const throttleId = useRef<Timeout>(null);

  const throttle = useCallback((throttledFunction: () => void, delay: number) => {
    if (throttleId.current) {
      return;
    }

    throttledFunction();

    throttleId.current = setTimeout(() => {
      throttleId.current = null;
    }, delay);
  }, []);

  const handleScroll = (event: React.UIEvent<HTMLElement>) => {
    const scrollTop = event.currentTarget.scrollTop;
    const scrollHeight = event.currentTarget.scrollHeight;
    const clientHeight = event.currentTarget.clientHeight;

    const scrollingDown = scrollTop > lastScrollTop.current;
    lastScrollTop.current = scrollTop;

    if (scrollingDown && scrollHeight - (clientHeight + scrollTop) <= nextThreshold) {
      throttle(props.next, throttleDelay);
    }
  };

  return (
    <ModalTemplate
      header={props.title}
      open={props.isOpen}
      size="medium"
      closeModal={props.closeModal}
    >
      <div className={classes.scrollArea} onScroll={handleScroll}>
        {props.children}
      </div>
    </ModalTemplate>
  );
};
